import api from '../../utils/axios';
import { useState, useCallback } from 'react';

interface CargoItem {
  Id: number;
  IdArea: number;
  Nombre: string;
  Activo: boolean;
  Eliminado: boolean;
  area?: {
    Id: number;
    Nombre: string;
  };
}

interface CargoDto {
  IdArea: number;
  Nombre: string;
  Activo: boolean;
}

const useCargosApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = '/administracion/cargos';

  const getAll = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.post<CargoItem[]>(`${baseUrl}/findAll`);
      return response.data.filter(item => !item.Eliminado);
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const create = useCallback(async (data: CargoDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/create`, {
        ...data,
        Eliminado: false
      });
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const update = useCallback(async (id: number, data: CargoDto) => {
    setIsLoading(true);
    try {
      const response = await api.post(`${baseUrl}/update/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const remove = useCallback(async (id: number) => {
    setIsLoading(true);
    try {
      await api.post(`${baseUrl}/softDelete/${id}`);
      return true;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    getAll,
    create,
    update,
    remove
  };
};

export { useCargosApi };
export type { CargoItem, CargoDto };